export function fuzzySearch(input, list) {
  if (!input) return list;
  const needle = String(input).toLowerCase();
  return list.filter((raw) => {
    const hay = String(raw).toLowerCase();
    let j = 0;
    for (let i = 0; i < hay.length && j < needle.length; i++) {
      if (hay[i] === needle[j]) j++;
    }
    return j === needle.length;
  });
}
